import {
  Alert,
  AlertTitle,
  Box,
  Button,
  CircularProgress,
  Divider,
  Paper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuItemMui from "@mui/material/MenuItem";
import timezone from "dayjs/plugin/timezone";
import { useEffect, useState } from "react";
import Header from "../../components/Header";
import { Grid2 } from "@mui/material";
import { Apartment, SaveAlt, TextSnippet } from "@mui/icons-material";
import { tokens } from "../../theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import NotificationToaste from "../global/NotificationToaste";
import dayjs, { utc } from "dayjs";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import { setPostPayload, setPutPayload } from "../../services/api";
import ProctorCompactionDetails from "./ProctorCompactionDetails";
import QuadraticChart from "./QuadraticChart";
import SimpleQuadraticChart from "./SimpleQuadraticChart";
import SimpleCompactionChart from "./SimpleCompactionChart";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const ProctorCompaction = ({
  data,
  selectedTest,
  loggedUser,
  setOpenReportDialog,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [authUsers, setAuthUsers] = useState([]);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [loading, setLoading] = useState(true);
  const [update, setUpdate] = useState(false);
  const [eachTest, setEachTest] = useState({
    serialNo: "AUTO",
    dateOfCast: "",
    dateOfTest: "",
    weight: "",
    concreteMixtureArray: "",
    areaOfCube: "",
    compressiveStrength: "",
  });

  const [chartData, setChartData] = useState({
    waterAddedText: "Water Added",
    waterAdded1: 0.0,
    waterAdded2: 0.0,
    waterAdded3: 0.0,
    waterAdded4: 0.0,
    waterAdded5: 0.0,

    cylinderWetSoilText: "Wt. Cylinder + Wet Soil (g)",
    cylinderWetSoil1: 0.0,
    cylinderWetSoil2: 0.0,
    cylinderWetSoil3: 0.0,
    cylinderWetSoil4: 0.0,
    cylinderWetSoil5: 0.0,

    cylinderText: "Wt. of Cylinder (g)",
    cylinder1: 0.0,
    cylinder2: 0.0,
    cylinder3: 0.0,
    cylinder4: 0.0,
    cylinder5: 0.0,

    wetSoilText: "Wt. of Wet Soil (g)",
    wetSoil1: 0.0,
    wetSoil2: 0.0,
    wetSoil3: 0.0,
    wetSoil4: 0.0,
    wetSoil5: 0.0,

    bulkWeightText: "Bulk Unit Weight (g/cm3)",
    bulkWeight1: 0.0,
    bulkWeight2: 0.0,
    bulkWeight3: 0.0,
    bulkWeight4: 0.0,
    bulkWeight5: 0.0,

    tinNoText: "Tin No",
    tinNo1_1: 0.0,
    tinNo1_2: 0.0,
    tinNo2_1: 0.0,
    tinNo2_2: 0.0,
    tinNo3_1: 0.0,
    tinNo3_2: 0.0,
    tinNo4_1: 0.0,
    tinNo4_2: 0.0,
    tinNo5_1: 0.0,
    tinNo5_2: 0.0,

    tinWetSoilText: "Wt. of Tin + Wet Soil (g)",
    tinWetSoil1_1: 0.0,
    tinWetSoil1_2: 0.0,
    tinWetSoil2_1: 0.0,
    tinWetSoil2_2: 0.0,
    tinWetSoil3_1: 0.0,
    tinWetSoil3_2: 0.0,
    tinWetSoil4_1: 0.0,
    tinWetSoil4_2: 0.0,
    tinWetSoil5_1: 0.0,
    tinWetSoil5_2: 0.0,

    tinDrySoilTExt: "Wt. of Tin + Dry Soil (g)",
    tinDrySoil1_1: 0.0,
    tinDrySoil1_2: 0.0,
    tinDrySoil2_1: 0.0,
    tinDrySoil2_2: 0.0,
    tinDrySoil3_1: 0.0,
    tinDrySoil3_2: 0.0,
    tinDrySoil4_1: 0.0,
    tinDrySoil4_2: 0.0,
    tinDrySoil5_1: 0.0,
    tinDrySoil5_2: 0.0,

    tinText: "Wt. of Tin  (g)",
    tin1_1: 0.0,
    tin1_2: 0.0,
    tin2_1: 0.0,
    tin2_2: 0.0,
    tin3_1: 0.0,
    tin3_2: 0.0,
    tin4_1: 0.0,
    tin4_2: 0.0,
    tin5_1: 0.0,
    tin5_2: 0.0,

    waterText: "Wt. of Water (g)",
    water1_1: 0.0,
    water1_2: 0.0,
    water2_1: 0.0,
    water2_2: 0.0,
    water3_1: 0.0,
    water3_2: 0.0,
    water4_1: 0.0,
    water4_2: 0.0,
    water5_1: 0.0,
    water5_2: 0.0,

    waterDrySoilText: "Wt. of Dry Soil (g)",
    waterDrySoil1_1: 0.0,
    waterDrySoil1_2: 0.0,
    waterDrySoil2_1: 0.0,
    waterDrySoil2_2: 0.0,
    waterDrySoil3_1: 0.0,
    waterDrySoil3_2: 0.0,
    waterDrySoil4_1: 0.0,
    waterDrySoil4_2: 0.0,
    waterDrySoil5_1: 0.0,
    waterDrySoil5_2: 0.0,

    mcText: "M.C. %",
    mc1_1: 0.0,
    mc1_2: 0.0,
    mc2_1: 0.0,
    mc2_2: 0.0,
    mc3_1: 0.0,
    mc3_2: 0.0,
    mc4_1: 0.0,
    mc4_2: 0.0,
    mc5_1: 0.0,
    mc5_2: 0.0,

    averageMcText: "Average M.C.",
    averageMc1: 0.0,
    averageMc2: 0.0,
    averageMc3: 0.0,
    averageMc4: 0.0,
    averageMc5: 0.0,

    dryUnitWeightText: "Dry Unit Weight (g/cm3)",
    dryUnitWeight1: 0.0,
    dryUnitWeight2: 0.0,
    dryUnitWeight3: 0.0,
    dryUnitWeight4: 0.0,
    dryUnitWeight5: 0.0,
  });

  // const calculationOfChart = () => {
  //   setChartData((pre) => ({
  //     ...pre,
  //     wetSoil1: pre.cylinderWetSoil1 - pre.cylinder1,
  //     wetSoil2: pre.cylinderWetSoil2 - pre.cylinder2,
  //     wetSoil3: pre.cylinderWetSoil3 - pre.cylinder3,
  //     wetSoil4: pre.cylinderWetSoil4 - pre.cylinder4,
  //     wetSoil5: pre.cylinderWetSoil5 - pre.cylinder5,

  //     bulkWeight1: ((pre.cylinderWetSoil1 - pre.cylinder1) / 995).toFixed(3),
  //     bulkWeight2: ((pre.cylinderWetSoil2 - pre.cylinder2) / 995).toFixed(3),
  //     bulkWeight3: ((pre.cylinderWetSoil3 - pre.cylinder3) / 995).toFixed(3),
  //     bulkWeight4: ((pre.cylinderWetSoil4 - pre.cylinder4) / 995).toFixed(3),
  //     bulkWeight5: ((pre.cylinderWetSoil5 - pre.cylinder5) / 995).toFixed(3),

  //     water1_1: pre.tinWetSoil1_1 - pre.tinDrySoil1_1,
  //     water1_2: pre.tinWetSoil1_2 - pre.tinDrySoil1_2,
  //     water2_1: pre.tinWetSoil2_1 - pre.tinDrySoil2_1,
  //     water2_2: pre.tinWetSoil2_2 - pre.tinDrySoil2_2,
  //     water3_1: pre.tinWetSoil3_1 - pre.tinDrySoil3_1,
  //     water3_2: pre.tinWetSoil3_2 - pre.tinDrySoil3_2,
  //     water4_1: pre.tinWetSoil4_1 - pre.tinDrySoil4_1,
  //     water4_2: pre.tinWetSoil4_2 - pre.tinDrySoil4_2,
  //     water5_1: pre.tinWetSoil5_1 - pre.tinDrySoil5_1,
  //     water5_2: pre.tinWetSoil5_2 - pre.tinDrySoil5_2,

  //     waterDrySoil1_1: pre.tinDrySoil1_1 - pre.tin1_1,
  //     waterDrySoil1_2: pre.tinDrySoil1_2 - pre.tin1_2,
  //     waterDrySoil2_1: pre.tinDrySoil2_1 - pre.tin2_1,
  //     waterDrySoil2_2: pre.tinDrySoil2_2 - pre.tin2_2,
  //     waterDrySoil3_1: pre.tinDrySoil3_1 - pre.tin3_1,
  //     waterDrySoil3_2: pre.tinDrySoil3_2 - pre.tin3_2,
  //     waterDrySoil4_1: pre.tinDrySoil4_1 - pre.tin4_1,
  //     waterDrySoil4_2: pre.tinDrySoil4_2 - pre.tin4_2,
  //     waterDrySoil5_1: pre.tinDrySoil5_1 - pre.tin5_1,
  //     waterDrySoil5_2: pre.tinDrySoil5_2 - pre.tin5_2,
  //   }));

  //   console.log("total ", chartData);
  // };

  // const calculationOfChartFinalVal = () => {
  //   setChartData((pre) => ({
  //     ...pre,
  //     mc1_1: (pre.water1_1 / pre.waterDrySoil1_1) * 100,
  //     mc1_2: (pre.water1_2 / pre.waterDrySoil1_2) * 100,
  //     mc2_1: (pre.water2_1 / pre.waterDrySoil2_1) * 100,
  //     mc2_2: (pre.water2_2 / pre.waterDrySoil2_2) * 100,
  //     mc3_1: (pre.water3_1 / pre.waterDrySoil3_1) * 100,
  //     mc3_2: (pre.water3_2 / pre.waterDrySoil3_2) * 100,
  //     mc4_1: (pre.water4_1 / pre.waterDrySoil4_1) * 100,
  //     mc4_2: (pre.water4_2 / pre.waterDrySoil4_2) * 100,
  //     mc5_1: (pre.water5_1 / pre.waterDrySoil5_1) * 100,
  //     mc5_2: (pre.water5_2 / pre.waterDrySoil5_2) * 100,

  //     averageMc1: (pre.mc1_1 + pre.mc1_2) / 2,
  //     averageMc2: (pre.mc2_1 + pre.mc2_2) / 2,
  //     averageMc3: (pre.mc3_1 + pre.mc3_2) / 2,
  //     averageMc4: (pre.mc4_1 + pre.mc4_2) / 2,
  //     averageMc5: (pre.mc5_1 + pre.mc5_2) / 2,

  //     dryUnitWeight1:
  //       (Number(pre.bulkWeight1) / (100 + (pre.mc1_1 + pre.mc1_2) / 2)) * 100,
  //     dryUnitWeight2:
  //       (pre.bulkWeight2 / (100 + (pre.mc2_1 + pre.mc2_2) / 2)) * 100,
  //     dryUnitWeight3:
  //       (pre.bulkWeight3 / (100 + (pre.mc3_1 + pre.mc3_2) / 2)) * 100,
  //     dryUnitWeight4:
  //       (pre.bulkWeight4 / (100 + (pre.mc4_1 + pre.mc4_2) / 2)) * 100,
  //     dryUnitWeight5:
  //       (pre.bulkWeight5 / (100 + (pre.mc5_1 + pre.mc5_2) / 2)) * 100,
  //   }));
  // };

  const calculateAll = () => {
    // First calculate intermediate values
    console.log("calculate");
    setChartData((pre) => {
      // Calculate first set
      const wetSoil1 = pre.cylinderWetSoil1 - pre.cylinder1;
      const wetSoil2 = pre.cylinderWetSoil2 - pre.cylinder2;
      const wetSoil3 = pre.cylinderWetSoil3 - pre.cylinder3;
      const wetSoil4 = pre.cylinderWetSoil4 - pre.cylinder4;
      const wetSoil5 = pre.cylinderWetSoil5 - pre.cylinder5;

      const bulkWeight1 = (wetSoil1 / 995).toFixed(3);
      const bulkWeight2 = (wetSoil2 / 995).toFixed(3);
      const bulkWeight3 = (wetSoil3 / 995).toFixed(3);
      const bulkWeight4 = (wetSoil4 / 995).toFixed(3);
      const bulkWeight5 = (wetSoil5 / 995).toFixed(3);

      const water1_1 = pre.tinWetSoil1_1 - pre.tinDrySoil1_1;
      const water1_2 = pre.tinWetSoil1_2 - pre.tinDrySoil1_2;
      const water2_1 = pre.tinWetSoil2_1 - pre.tinDrySoil2_1;
      const water2_2 = pre.tinWetSoil2_2 - pre.tinDrySoil2_2;
      const water3_1 = pre.tinWetSoil3_1 - pre.tinDrySoil3_1;
      const water3_2 = pre.tinWetSoil3_2 - pre.tinDrySoil3_2;
      const water4_1 = pre.tinWetSoil4_1 - pre.tinDrySoil4_1;
      const water4_2 = pre.tinWetSoil4_2 - pre.tinDrySoil4_2;
      const water5_1 = pre.tinWetSoil5_1 - pre.tinDrySoil5_1;
      const water5_2 = pre.tinWetSoil5_2 - pre.tinDrySoil5_2;

      const waterDrySoil1_1 = pre.tinDrySoil1_1 - pre.tin1_1;
      const waterDrySoil1_2 = pre.tinDrySoil1_2 - pre.tin1_2;
      const waterDrySoil2_1 = pre.tinDrySoil2_1 - pre.tin2_1;
      const waterDrySoil2_2 = pre.tinDrySoil2_2 - pre.tin2_2;
      const waterDrySoil3_1 = pre.tinDrySoil3_1 - pre.tin3_1;
      const waterDrySoil3_2 = pre.tinDrySoil3_2 - pre.tin3_2;
      const waterDrySoil4_1 = pre.tinDrySoil4_1 - pre.tin4_1;
      const waterDrySoil4_2 = pre.tinDrySoil4_2 - pre.tin4_2;
      const waterDrySoil5_1 = pre.tinDrySoil5_1 - pre.tin5_1;
      const waterDrySoil5_2 = pre.tinDrySoil5_2 - pre.tin5_2;

      // Calculate second set
      const mc1_1 = (water1_1 / waterDrySoil1_1) * 100;
      const mc1_2 = (water1_2 / waterDrySoil1_2) * 100;
      const mc2_1 = (water2_1 / waterDrySoil2_1) * 100;
      const mc2_2 = (water2_2 / waterDrySoil2_2) * 100;
      const mc3_1 = (water3_1 / waterDrySoil3_1) * 100;
      const mc3_2 = (water3_2 / waterDrySoil3_2) * 100;
      const mc4_1 = (water4_1 / waterDrySoil4_1) * 100;
      const mc4_2 = (water4_2 / waterDrySoil4_2) * 100;
      const mc5_1 = (water5_1 / waterDrySoil5_1) * 100;
      const mc5_2 = (water5_2 / waterDrySoil5_2) * 100;

      const averageMc1 = (mc1_1 + mc1_2) / 2;
      const averageMc2 = (mc2_1 + mc2_2) / 2;
      const averageMc3 = (mc3_1 + mc3_2) / 2;
      const averageMc4 = (mc4_1 + mc4_2) / 2;
      const averageMc5 = (mc5_1 + mc5_2) / 2;

      const dryUnitWeight1 = (Number(bulkWeight1) / (100 + averageMc1)) * 100;
      const dryUnitWeight2 = (bulkWeight2 / (100 + averageMc2)) * 100;
      const dryUnitWeight3 = (bulkWeight3 / (100 + averageMc3)) * 100;
      const dryUnitWeight4 = (bulkWeight4 / (100 + averageMc4)) * 100;
      const dryUnitWeight5 = (bulkWeight5 / (100 + averageMc5)) * 100;

      return {
        ...pre,
        wetSoil1,
        wetSoil2,
        wetSoil3,
        wetSoil4,
        wetSoil5,

        bulkWeight1,
        bulkWeight2,
        bulkWeight3,
        bulkWeight4,
        bulkWeight5,

        water1_1,
        water1_2,
        water2_1,
        water2_2,
        water3_1,
        water3_2,
        water4_1,
        water4_2,
        water5_1,
        water5_2,

        waterDrySoil1_1,
        waterDrySoil1_2,
        waterDrySoil2_1,
        waterDrySoil2_2,
        waterDrySoil3_1,
        waterDrySoil3_2,
        waterDrySoil4_1,
        waterDrySoil4_2,
        waterDrySoil5_1,
        waterDrySoil5_2,

        mc1_1,
        mc1_2,
        mc2_1,
        mc2_2,
        mc3_1,
        mc3_2,
        mc4_1,
        mc4_2,
        mc5_1,
        mc5_2,

        averageMc1,
        averageMc2,
        averageMc3,
        averageMc4,
        averageMc5,

        dryUnitWeight1,
        dryUnitWeight2,
        dryUnitWeight3,
        dryUnitWeight4,
        dryUnitWeight5,
      };
    });
  };

  console.log(chartData);

  const [mainData, setMainData] = useState({
    date: dayjs(new Date()).format("YYYY-MM-DD"),
    institute: data.institute,
    reference: "",
    sampleLocation: "",
    cement: "",
    grade: "",
    concreteMixture: "",
    areaOfCube: "5000",
    dateOfCast: dayjs(new Date()).format("YYYY-MM-DD"),
    dateOfTest: dayjs(new Date()).format("YYYY-MM-DD"),
    testDays: "",
    labTestsDataFromSubs: [],
    specialNote:
      "The test results reported herein relate to the specimens submitted to material testing laboratory & we do not certify the quality of a product / site in general.",
    remarks: "",
    reportType: "PROC",
    sampleTakenBy: "",
    testedBy: { id: "" },
    reportedBy: loggedUser,
    authorizedBy: null,
    labRequest: data,
    barcode: "",
    labRequestTests: selectedTest,
    referenceReportNumber: "",
    rejectReason: "",
  });

  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const chartDataTemp = {
    averageMc1: "12",
    averageMc2: "14",
    averageMc3: "16",
    averageMc4: "18",
    averageMc5: "20",
    dryUnitWeight1: "1",
    dryUnitWeight2: "2",
    dryUnitWeight3: "3",
    dryUnitWeight4: "4",
    dryUnitWeight5: "5",
    averageMcText: "Average M.C.",
    dryUnitWeightText: "Dry Unit Weight (g/cm3)",
  };

  useEffect(() => {
    loadBasicData();
    // setTimeout(() => {
    //   calculationOfChart();
    // }, 5000);
    return () => loadBasicData();
  }, []);

  const loadBasicData = async () => {
    // console.log("selectedid ", selectedTest.id);
    setLoading(true);

    await axios
      .get(DATA_SAVE_URL + "/api/v1/dataForm/reportData/" + data.id, {
        params: {
          testId: selectedTest.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(function (response) {
        console.log("tada", response.data);
        if (response.data.labTestFormData !== null) {
          setUpdate(true);
          setMainData(response.data.labTestFormData);
          //   console.log("asss", response.data);
          const chartTableData =
            response.data.labTestFormData.labTestDataProctorSubs;
          //   console.log("data ,", chartTableData);

          //   console.log("read data", mainData);

          setChartData((pre) => ({
            ...pre,

            waterAddedText: chartTableData[0]?.description,
            waterAdded1: chartTableData[0]?.tab1_1,
            waterAdded2: chartTableData[0]?.tab2_1,
            waterAdded3: chartTableData[0]?.tab3_1,
            waterAdded4: chartTableData[0]?.tab4_1,
            waterAdded5: chartTableData[0]?.tab5_1,

            cylinderWetSoilText: chartTableData[1]?.description,
            cylinderWetSoil1: chartTableData[1]?.tab1_1,
            cylinderWetSoil2: chartTableData[1]?.tab2_1,
            cylinderWetSoil3: chartTableData[1]?.tab3_1,
            cylinderWetSoil4: chartTableData[1]?.tab4_1,
            cylinderWetSoil5: chartTableData[1]?.tab5_1,

            cylinderText: chartTableData[2]?.description,
            cylinder1: chartTableData[2]?.tab1_1,
            cylinder2: chartTableData[2]?.tab2_1,
            cylinder3: chartTableData[2]?.tab3_1,
            cylinder4: chartTableData[2]?.tab4_1,
            cylinder5: chartTableData[2]?.tab5_1,

            wetSoilText: chartTableData[3]?.description,
            wetSoil1: chartTableData[3]?.tab1_1,
            wetSoil2: chartTableData[3]?.tab2_1,
            wetSoil3: chartTableData[3]?.tab3_1,
            wetSoil4: chartTableData[3]?.tab4_1,
            wetSoil5: chartTableData[3]?.tab5_1,

            bulkWeightText: chartTableData[4]?.description,
            bulkWeight1: chartTableData[4]?.tab1_1,
            bulkWeight2: chartTableData[4]?.tab2_1,
            bulkWeight3: chartTableData[4]?.tab3_1,
            bulkWeight4: chartTableData[4]?.tab4_1,
            bulkWeight5: chartTableData[4]?.tab5_1,

            tinNoText: chartTableData[5]?.description,
            tinNo1_1: chartTableData[5]?.tab1_1,
            tinNo1_2: chartTableData[5]?.tab1_2,
            tinNo2_1: chartTableData[5]?.tab2_1,
            tinNo2_2: chartTableData[5]?.tab2_2,
            tinNo3_1: chartTableData[5]?.tab3_1,
            tinNo3_2: chartTableData[5]?.tab3_2,
            tinNo4_1: chartTableData[5]?.tab4_1,
            tinNo4_2: chartTableData[5]?.tab4_2,
            tinNo5_1: chartTableData[5]?.tab5_1,
            tinNo5_2: chartTableData[5]?.tab5_2,

            tinWetSoilText: "Wt. of Tin + Wet Soil (g)",
            tinWetSoil1_1: chartTableData[6]?.tab1_1,
            tinWetSoil1_2: chartTableData[6]?.tab1_2,
            tinWetSoil2_1: chartTableData[6]?.tab2_1,
            tinWetSoil2_2: chartTableData[6]?.tab2_2,
            tinWetSoil3_1: chartTableData[6]?.tab3_1,
            tinWetSoil3_2: chartTableData[6]?.tab3_2,
            tinWetSoil4_1: chartTableData[6]?.tab4_1,
            tinWetSoil4_2: chartTableData[6]?.tab4_2,
            tinWetSoil5_1: chartTableData[6]?.tab5_1,
            tinWetSoil5_2: chartTableData[6]?.tab5_2,

            tinDrySoilTExt: "Wt. of Tin + Dry Soil (g)",
            tinDrySoil1_1: chartTableData[7]?.tab1_1,
            tinDrySoil1_2: chartTableData[7]?.tab1_2,
            tinDrySoil2_1: chartTableData[7]?.tab2_1,
            tinDrySoil2_2: chartTableData[7]?.tab2_2,
            tinDrySoil3_1: chartTableData[7]?.tab3_1,
            tinDrySoil3_2: chartTableData[7]?.tab3_2,
            tinDrySoil4_1: chartTableData[7]?.tab4_1,
            tinDrySoil4_2: chartTableData[7]?.tab4_2,
            tinDrySoil5_1: chartTableData[7]?.tab5_1,
            tinDrySoil5_2: chartTableData[7]?.tab5_2,

            tinText: "Wt. of Tin  (g)",
            tin1_1: chartTableData[8]?.tab1_1,
            tin1_2: chartTableData[8]?.tab1_2,
            tin2_1: chartTableData[8]?.tab2_1,
            tin2_2: chartTableData[8]?.tab2_2,
            tin3_1: chartTableData[8]?.tab3_1,
            tin3_2: chartTableData[8]?.tab3_2,
            tin4_1: chartTableData[8]?.tab4_1,
            tin4_2: chartTableData[8]?.tab4_2,
            tin5_1: chartTableData[8]?.tab5_1,
            tin5_2: chartTableData[8]?.tab5_2,

            waterText: "Wt. of Water (g)",
            water1_1: chartTableData[9]?.tab1_1,
            water1_2: chartTableData[9]?.tab1_2,
            water2_1: chartTableData[9]?.tab2_1,
            water2_2: chartTableData[9]?.tab2_2,
            water3_1: chartTableData[9]?.tab3_1,
            water3_2: chartTableData[9]?.tab3_2,
            water4_1: chartTableData[9]?.tab4_1,
            water4_2: chartTableData[9]?.tab4_2,
            water5_1: chartTableData[9]?.tab5_1,
            water5_2: chartTableData[9]?.tab5_2,

            waterDrySoilText: "Wt. of Dry Soil (g)",
            waterDrySoil1_1: chartTableData[10]?.tab1_1,
            waterDrySoil1_2: chartTableData[10]?.tab1_2,
            waterDrySoil2_1: chartTableData[10]?.tab2_1,
            waterDrySoil2_2: chartTableData[10]?.tab2_2,
            waterDrySoil3_1: chartTableData[10]?.tab3_1,
            waterDrySoil3_2: chartTableData[10]?.tab3_2,
            waterDrySoil4_1: chartTableData[10]?.tab4_1,
            waterDrySoil4_2: chartTableData[10]?.tab4_2,
            waterDrySoil5_1: chartTableData[10]?.tab5_1,
            waterDrySoil5_2: chartTableData[10]?.tab5_2,

            mcText: "M.C. %",
            mc1_1: chartTableData[11]?.tab1_1,
            mc1_2: chartTableData[11]?.tab1_2,
            mc2_1: chartTableData[11]?.tab2_1,
            mc2_2: chartTableData[11]?.tab2_2,
            mc3_1: chartTableData[11]?.tab3_1,
            mc3_2: chartTableData[11]?.tab3_2,
            mc4_1: chartTableData[11]?.tab4_1,
            mc4_2: chartTableData[11]?.tab4_2,
            mc5_1: chartTableData[11]?.tab5_1,
            mc5_2: chartTableData[11]?.tab5_2,

            averageMcText: "Average M.C.",
            averageMc1: chartTableData[12]?.tab1_1,
            averageMc2: chartTableData[12]?.tab2_1,
            averageMc3: chartTableData[12]?.tab3_1,
            averageMc4: chartTableData[12]?.tab4_1,
            averageMc5: chartTableData[12]?.tab5_1,

            dryUnitWeightText: "Dry Unit Weight (g/cm3)",
            dryUnitWeight1: chartTableData[13]?.tab1_1,
            dryUnitWeight2: chartTableData[13]?.tab2_1,
            dryUnitWeight3: chartTableData[13]?.tab3_1,
            dryUnitWeight4: chartTableData[13]?.tab4_1,
            dryUnitWeight5: chartTableData[13]?.tab5_1,
          }));
        } else {
          addCubesToTable();
        }

        setAuthUsers(response.data.authUsers);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
      });
    setLoading(false);
  };

  const addCubesToTable = () => {
    console.log("data qty " + selectedTest.quantity);
    const newItems = Array.from({ length: selectedTest.quantity }, (_, i) => ({
      serialNo: selectedTest.startingSerialNo + i,
      dateOfCast: dayjs(mainData.dateOfCast).format("YYYY-MM-DD"),
      dateOfTest: dayjs(mainData.dateOfTest).format("YYYY-MM-DD"),
      areaOfCube: mainData.areaOfCube,
      weight: "",
      compressiveStrength: "",
      concreteMixture: mainData.concreteMixture,
    }));
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: newItems,
    }));
  };

  const addTestHandle = () => {
    // console.log("added test data ", eachTest);

    const updatedTest = {
      ...eachTest, // or pre if it's based on previous state
      dateOfCast: dayjs(mainData.dateOfCast).format("YYYY-MM-DD"),
      dateOfTest: dayjs(mainData.dateOfTest).format("YYYY-MM-DD"),
      areaOfCube: "22500",
      concreteMixture: mainData.concreteMixture,
    };

    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: [...pre.labTestsDataFromSubs, updatedTest],
    }));
  };

  const rearrangeChartArray = () => {
    const proctorArray = [];

    proctorArray.push(
      {
        description: chartData.waterAddedText,
        tab1_1: chartData.waterAdded1,
        tab1_2: 0.0,
        tab2_1: chartData.waterAdded2,
        tab2_2: 0.0,
        tab3_1: chartData.waterAdded3,
        tab3_2: 0.0,
        tab4_1: chartData.waterAdded4,
        tab4_2: 0.0,
        tab5_1: chartData.waterAdded5,
        tab5_2: 0.0,
      },
      {
        description: chartData.cylinderWetSoilText,
        tab1_1: chartData.cylinderWetSoil1,
        tab1_2: 0.0,
        tab2_1: chartData.cylinderWetSoil2,
        tab2_2: 0.0,
        tab3_1: chartData.cylinderWetSoil3,
        tab3_2: 0.0,
        tab4_1: chartData.cylinderWetSoil4,
        tab4_2: 0.0,
        tab5_1: chartData.cylinderWetSoil5,
        tab5_2: 0.0,
      },

      {
        description: chartData.cylinderText,
        tab1_1: chartData.cylinder1,
        tab1_2: 0.0,
        tab2_1: chartData.cylinder2,
        tab2_2: 0.0,
        tab3_1: chartData.cylinder3,
        tab3_2: 0.0,
        tab4_1: chartData.cylinder4,
        tab4_2: 0.0,
        tab5_1: chartData.cylinder5,
        tab5_2: 0.0,
      },
      {
        description: chartData.wetSoilText,
        tab1_1: chartData.wetSoil1,
        tab1_2: 0.0,
        tab2_1: chartData.wetSoil2,
        tab2_2: 0.0,
        tab3_1: chartData.wetSoil3,
        tab3_2: 0.0,
        tab4_1: chartData.wetSoil4,
        tab4_2: 0.0,
        tab5_1: chartData.wetSoil5,
        tab5_2: 0.0,
      },
      {
        description: chartData.bulkWeightText,
        tab1_1: chartData.bulkWeight1,
        tab1_2: 0.0,
        tab2_1: chartData.bulkWeight2,
        tab2_2: 0.0,
        tab3_1: chartData.bulkWeight3,
        tab3_2: 0.0,
        tab4_1: chartData.bulkWeight4,
        tab4_2: 0.0,
        tab5_1: chartData.bulkWeight5,
        tab5_2: 0.0,
      },
      {
        description: chartData.tinNoText,
        tab1_1: chartData.tinNo1_1,
        tab1_2: chartData.tinNo1_2,
        tab2_1: chartData.tinNo2_1,
        tab2_2: chartData.tinNo2_2,
        tab3_1: chartData.tinNo3_1,
        tab3_2: chartData.tinNo3_2,
        tab4_1: chartData.tinNo4_1,
        tab4_2: chartData.tinNo4_2,
        tab5_1: chartData.tinNo5_1,
        tab5_2: chartData.tinNo5_2,
      },

      {
        description: chartData.tinWetSoilText,
        tab1_1: chartData.tinWetSoil1_1,
        tab1_2: chartData.tinWetSoil1_2,
        tab2_1: chartData.tinWetSoil2_1,
        tab2_2: chartData.tinWetSoil2_2,
        tab3_1: chartData.tinWetSoil3_1,
        tab3_2: chartData.tinWetSoil3_2,
        tab4_1: chartData.tinWetSoil4_1,
        tab4_2: chartData.tinWetSoil4_2,
        tab5_1: chartData.tinWetSoil5_1,
        tab5_2: chartData.tinWetSoil5_2,
      },
      {
        description: chartData.tinDrySoilTExt,
        tab1_1: chartData.tinDrySoil1_1,
        tab1_2: chartData.tinDrySoil1_2,
        tab2_1: chartData.tinDrySoil2_1,
        tab2_2: chartData.tinDrySoil2_2,
        tab3_1: chartData.tinDrySoil3_1,
        tab3_2: chartData.tinDrySoil3_2,
        tab4_1: chartData.tinDrySoil4_1,
        tab4_2: chartData.tinDrySoil4_2,
        tab5_1: chartData.tinDrySoil5_1,
        tab5_2: chartData.tinDrySoil5_2,
      },
      {
        description: chartData.tinText,
        tab1_1: chartData.tin1_1,
        tab1_2: chartData.tin1_2,
        tab2_1: chartData.tin2_1,
        tab2_2: chartData.tin2_2,
        tab3_1: chartData.tin3_1,
        tab3_2: chartData.tin3_2,
        tab4_1: chartData.tin4_1,
        tab4_2: chartData.tin4_2,
        tab5_1: chartData.tin5_1,
        tab5_2: chartData.tin5_2,
      },
      {
        description: chartData.waterText,
        tab1_1: chartData.water1_1.toFixed(2),
        tab1_2: chartData.water1_2.toFixed(2),
        tab2_1: chartData.water2_1.toFixed(2),
        tab2_2: chartData.water2_2.toFixed(2),
        tab3_1: chartData.water3_1.toFixed(2),
        tab3_2: chartData.water3_2.toFixed(2),
        tab4_1: chartData.water4_1.toFixed(2),
        tab4_2: chartData.water4_2.toFixed(2),
        tab5_1: chartData.water5_1.toFixed(2),
        tab5_2: chartData.water5_2.toFixed(2),
      },
      {
        description: chartData.waterDrySoilText,
        tab1_1: chartData.waterDrySoil1_1.toFixed(2),
        tab1_2: chartData.waterDrySoil1_2.toFixed(2),
        tab2_1: chartData.waterDrySoil2_1.toFixed(2),
        tab2_2: chartData.waterDrySoil2_2.toFixed(2),
        tab3_1: chartData.waterDrySoil3_1.toFixed(2),
        tab3_2: chartData.waterDrySoil3_2.toFixed(2),
        tab4_1: chartData.waterDrySoil4_1.toFixed(2),
        tab4_2: chartData.waterDrySoil4_2.toFixed(2),
        tab5_1: chartData.waterDrySoil5_1.toFixed(2),
        tab5_2: chartData.waterDrySoil5_2.toFixed(2),
      },

      {
        description: chartData.mcText,
        tab1_1: chartData.mc1_1.toFixed(2),
        tab1_2: chartData.mc1_2.toFixed(2),
        tab2_1: chartData.mc2_1.toFixed(2),
        tab2_2: chartData.mc2_2.toFixed(2),
        tab3_1: chartData.mc3_1.toFixed(2),
        tab3_2: chartData.mc3_2.toFixed(2),
        tab4_1: chartData.mc4_1.toFixed(2),
        tab4_2: chartData.mc4_2.toFixed(2),
        tab5_1: chartData.mc5_1.toFixed(2),
        tab5_2: chartData.mc5_2.toFixed(2),
      },
      {
        description: chartData.averageMcText,
        tab1_1: chartData.averageMc1.toFixed(2),
        tab1_2: "0.00",
        tab2_1: chartData.averageMc2.toFixed(2),
        tab2_2: "0.00",
        tab3_1: chartData.averageMc3.toFixed(2),
        tab3_2: "0.00",
        tab4_1: chartData.averageMc4.toFixed(2),
        tab4_2: "0.00",
        tab5_1: chartData.averageMc5.toFixed(2),
        tab5_2: "0.00",
      },

      {
        description: chartData.dryUnitWeightText,
        tab1_1: chartData.dryUnitWeight1.toFixed(2),
        tab1_2: "0.00",
        tab2_1: chartData.dryUnitWeight2.toFixed(2),
        tab2_2: "0.00",
        tab3_1: chartData.dryUnitWeight3.toFixed(2),
        tab3_2: "0.00",
        tab4_1: chartData.dryUnitWeight4.toFixed(2),
        tab4_2: "0.00",
        tab5_1: chartData.dryUnitWeight5.toFixed(2),
        tab5_2: "0.00",
      },
    );
    return proctorArray;
  };

  const handleSaveData = async () => {
    if (mainData.testedBy.id === "") {
      setMessage("Select tested by user..!");
      setMessageType("warning");
      setOpen(true);
      return;
    }

    if (!update) {
      setLoading(true);

      //Add sieve data details to main objec array

      const sendObject = {
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestDataProctorSubs: rearrangeChartArray(),
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "PROC",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData.testedBy.id },
        reportedBy: { id: mainData.reportedBy.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: "",
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
      };
      console.log("main data save sendObject ", sendObject);
      await setPostPayload
        .setPayloadData("/dataForm/saveReport", sendObject)

        .then(function (response) {
          console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          // handleClose();
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    } else {
      setLoading(true);
      // console.log("main data ", mainData);
      setMainData((pre) => ({
        ...pre,
        id: mainData.id,
      }));

      console.log("***asss*********", mainData);

      const sendObject = {
        id: mainData.id,
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestDataProctorSubs: rearrangeChartArray(),
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "PROC",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData.testedBy.id },
        reportedBy: { id: mainData.reportedBy.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: mainData.barcode,
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
      };

      console.log("************", sendObject);

      await setPutPayload
        .setPayloadData("/dataForm/updateReport", sendObject)
        .then(function (response) {
          // console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 0 0 0",
        margin: "0 0 0 0",
      }}
    >
      {mainData.rejectReason === null || mainData.rejectReason === "" ? (
        ""
      ) : (
        <Stack sx={{ width: "100%", marginBottom: "5px" }}>
          <Alert severity="error" width="100%">
            <AlertTitle>This report is rejected.</AlertTitle>
            Reason : {mainData?.rejectReason}
          </Alert>
        </Stack>
      )}

      <Paper
        sx={{
          padding: "10px",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header
          title="PROCTOR COMPACTION TEST REPORT."
          subtitle="GENERAL DATA"
        />
        <Box>
          <Grid2 container spacing={1}>
            <Grid2 size={8}>
              <Paper elevation={2} sx={{ padding: "10px" }}>
                <Grid2 container spacing={2}>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <TextSnippet />
                      <Typography variant="h5">PROJECT</Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.project}
                    </Typography>
                  </Grid2>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <Apartment />
                      <Typography variant="h5" component="h2">
                        INSTITUTE NAME
                      </Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.institute.instituteName}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Reference"
                      value={mainData.reference}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          reference: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Sample Locations"
                      value={mainData.sampleLocation}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          sampleLocation: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Report Reference Number"
                      value={mainData.referenceReportNumber}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          referenceReportNumber: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
            <Grid2 size={4}>
              <Paper elevation={2} sx={{ padding: "10px", height: "100%" }}>
                <Grid2 container>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT NUMBER</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {update
                        ? "QC/" +
                          mainData.reportType +
                          "/" +
                          mainData.labRequest.year +
                          "/" +
                          String(mainData.id).padStart(4, "0")
                        : "AUTO"}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">JOB NO</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {data.year + "/" + String(data.id).padStart(4, "0")}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT DATE</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center" justifyItems="center">
                    <Box sx={{ width: "200px" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DatePicker"]}
                          sx={{ paddingTop: "8px" }}
                        >
                          <DatePicker
                            label="Date of report"
                            size="small"
                            format="YYYY-MM-DD"
                            timezone="Asia/Colombo"
                            value={
                              mainData.date
                                ? dayjs(mainData.date).tz("Asia/Colombo", true)
                                : dayjs(new Date()).tz("Asia/Colombo", true)
                            }
                            onChange={(newValue) => {
                              const colomboTime = newValue?.tz(
                                "Asia/Colombo",
                                true,
                              );
                              setMainData((pre) => ({
                                ...pre,
                                date: dayjs(colomboTime).format("YYYY-MM-DD"),
                              }));
                            }}
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Box>
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
          </Grid2>
        </Box>
      </Paper>
      <Paper
        sx={{ borderRadius: "8px", padding: "10px", width: "100%" }}
        elevation={3}
      >
        <Header
          title="STANDARD PROCTOR COMPACTION TEST"
          subtitle="ENTER TESTING DATA"
        />
        <Divider sx={{ margin: "10px 0px 10px 0" }} />
        <ProctorCompactionDetails
          isNonMobile={isNonMobile}
          chartData={chartData}
          setChartData={setChartData}
          calculateAll={calculateAll}
        />
        {/* <QuadraticChart />
        <SimpleQuadraticChart /> */}
        <SimpleCompactionChart data={chartData} />
      </Paper>
      {loading ? (
        <CircularProgress
          sx={{
            color: colors.greenAccent[500],
            position: "absolute",
            zIndex: 10,
          }}
        />
      ) : (
        ""
      )}
      <Paper
        sx={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          marginTop: "80px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header title="TEST NOTES" subtitle="AUTHORIZE DATA" />
        <Grid2 container spacing={1} marginTop="10px">
          <Grid2 size={12}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Special Notes"
              value={mainData.specialNote}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  specialNote: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Remarks"
              value={mainData.remarks}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  remarks: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={4}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Sample taken / supplied by"
              value={mainData.sampleTakenBy}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  sampleTakenBy: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={2}>
            <TextField
              select
              label="Tested by"
              fullWidth
              size="small"
              defaultValue=""
              value={mainData.testedBy.id}
              onChange={(e) => {
                e.preventDefault();
                setMainData((pre) => ({
                  ...pre,
                  testedBy: {
                    ...pre.testedBy,
                    id: e.target.value,
                  },
                }));
              }}
            >
              {authUsers.map((data) => (
                <MenuItemMui key={data.id} value={data.id}>
                  {data.firstName + " " + data.lastName}
                </MenuItemMui>
              ))}
            </TextField>
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Divider sx={{ width: "100%" }} />
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              color="secondary"
              loading={loading}
              startIcon={<SaveAlt />}
              variant="contained"
              onClick={handleSaveData}
            >
              Save Data
            </Button>
          </Grid2>
        </Grid2>
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
    </Box>
  );
};

export default ProctorCompaction;
